"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestFormatter = void 0;
var addressFormatter = function addressFormatter(address1, address2, city, usState, zip, country) {
  return [address1, address2, city, usState, zip, country].filter(function (v) {
    return v;
  }).join(', ');
};
var requestFormatter = function requestFormatter(_ref) {
  var abimNumber = _ref.abimNumber,
    start = _ref.start,
    selectedCredits = _ref.selectedCredits,
    content = _ref.content,
    quality = _ref.quality,
    usefullness = _ref.usefullness,
    overallEvaluation = _ref.overallEvaluation,
    name = _ref.name,
    end = _ref.end,
    degree = _ref.degree,
    freeOfBias = _ref.freeOfBias,
    effectiveness = _ref.effectiveness,
    practiceChanges = _ref.practiceChanges,
    learningObjectives = _ref.learningObjectives,
    dateOfBirth = _ref.dateOfBirth,
    city = _ref.city,
    usState = _ref.usState,
    address1 = _ref.address1,
    address2 = _ref.address2,
    country = _ref.country,
    zip = _ref.zip,
    cmeCreditTrackerId = _ref.cmeCreditTrackerId,
    questionsLoggedForCredit = _ref.questionsLoggedForCredit,
    dayOfBirth = _ref.dayOfBirth,
    monthOfBirth = _ref.monthOfBirth,
    stateOfMedicalLicense = _ref.stateOfMedicalLicense;
  // "YYYY-MM-DD"
  var dob = dateOfBirth.split('-');
  var neededState = country === "United States" ? usState : '';
  return {
    selected_hours_count: selectedCredits,
    cme_credit_tracker_id: cmeCreditTrackerId,
    questions_logged_for_credit: _toConsumableArray(questionsLoggedForCredit),
    lower_bound: start,
    upper_bound: end,
    evaluation_answers: _objectSpread(_objectSpread(_objectSpread({
      name: name,
      degree: degree,
      "ABIM Number": abimNumber,
      free_of_bias: _objectSpread({}, freeOfBias),
      practice_changes: _objectSpread({}, practiceChanges),
      effectiveness: _toConsumableArray(effectiveness),
      learning_objectives: _toConsumableArray(learningObjectives),
      "Birth Day": dayOfBirth || dob[2],
      "Birth Month": monthOfBirth || dob[1]
    }, !dayOfBirth && {
      "Birth Year": dob[0],
      "Date of Birth": "".concat(dob[1], "/").concat(dob[2], "/").concat(dob[0])
    }), !stateOfMedicalLicense ? {
      location: {
        formatted_address: addressFormatter(address1, address2, city, neededState, zip, country),
        address_1: address1,
        address_2: address2,
        city: city,
        state: neededState,
        country: country,
        zip: zip
      }
    } : {
      "State Of Medical License": stateOfMedicalLicense
    }), {}, {
      "Overall Evaluation": overallEvaluation,
      Content: content,
      Quality: quality,
      Usefulness: usefullness
    })
  };
};
exports.requestFormatter = requestFormatter;